/* eslint-disable no-unused-vars */
const MAIN_APPLICATION_CONTEXT_PATH = '/s2'

// const BASE_URL =
//     process.env.REACT_APP_BASE_URL +
//     process.env.REACT_APP_MAIN_APPLICATION_CONTEXT_PATH
// const BASE_URL = 'https://apiv2.evolvfit.in'
const BASE_URL = 'https://apiv2.evolvfit.in'
const ADMIN_EMAILS = ['connectswadhin@gmail.com', 'sharabh@evolvfit.in']
const isAdmin = (email) => ADMIN_EMAILS.includes(email)
const LOCALHOST_BASE_URL = 'http://192.168.1.80:5000'

const NGROK_URL =
    'https://19d9ec50a9a1.ngrok.io' + MAIN_APPLICATION_CONTEXT_PATH

export default BASE_URL
export { ADMIN_EMAILS, isAdmin }
